import React, { useEffect, useState } from "react";
import Box from "@mui/material/Box";
import { styled } from "@mui/material/styles";
import { useSearchParams } from "react-router-dom";
import Grid from "@mui/material/Grid2";
import { Typography } from "@mui/material";
import SelectInput from "../../components/TextInput/SelectInput";
import InfinityEncryptor from "../../components/EncryptDecrypt/InfinityEncryptor";
import { useForm } from "react-hook-form";
import TextInput from "../../components/TextInput/TextInput";
import BasicDatePicker from "../../components/DatePicker/BasicDatePicker";
import LandLinePhoneFormatter from "../../components/PhoneFormatter/LandLinePhoneFormatter";
import { Controller } from "react-hook-form";
import { MuiTelInput } from "mui-tel-input";
import Button from "@mui/material/Button";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import CorporateMembershipController from "./Controller/corporate_membership_controller.ts";
import Alert from "@mui/material/Alert";
import { notification } from "antd";
import Chip from "@mui/material/Chip";
import CustomSeparator from "../../layouts/AdminLayout/Header/Breadcrumbs.js";

const DrawerHeader = styled("div")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "flex-end",
  padding: theme.spacing(0, 1),
  // necessary for content to be below app bar
  ...theme.mixins.toolbar,
}));

const AddCorporateMember = () => {
  const [api, contextHolder] = notification.useNotification();

  const openNotificationWithIcon = (type, message) => {
    api[type]({
      message: "Success",
      description: message,
    });
  };

  const [searchParams] = useSearchParams();
  const memberID = searchParams.get("memberID");

  const [allotmentLeft, setAllotmentLeft] = useState(0);
  const [accounts_allotment, setAccountsAllotment] = useState(0);

  const [membership_registrationID, setMembershipRegistrationID] = useState("");
  const [data, setData] = useState([]);
  const [shouldRefetchData, setShouldRefetchData] = useState(false);

  useEffect(() => {
    if (memberID) {
      const payload = new FormData();
      payload.append("memberID", memberID);

      CorporateMembershipController.getMemberInfo(payload).then((response) => {
        setData(response);
        setMembershipRegistrationID(response.membership_registrationID);
        setAccountsAllotment(response.accounts_allotment);
        setAllotmentLeft(parseInt(response.allotment_left, 10) || 0); // Ensure it's a number
      });
    }
  }, [memberID, shouldRefetchData]);

  //parameters declaration
  const key = "12345";
  const mode = "YMDHI"; //optional parameter, default will be 'YMDHI'
  //initialize encyptor
  const Encryptor = new InfinityEncryptor(key, mode);
  const {
    handleSubmit,
    register,
    formState: { errors },
    control,
    reset,
  } = useForm({
    defaultValues: {
      othersSalutation: "",
      othersName: "",
      othersNRIC: "",
      othersEmail: "",
      othersHPNo: "",
      othersDOB: "",
      othersOfficeTelNo: "",
      othersDesignation: "",
      othersNatureOfWork: "",
      othersNoOfYearsWithCompany: "",
      othersAcademicQualification: "",
    },
  });

  const onSubmit = async (data) => {
    // if (Object.keys(errors).length > 0) {
    //   console.log("Form has errors:", errors);
    //   return; // Prevent submission if there are errors
    // }

    const formData = new FormData();

    formData.append(
      "others_salutation",
      Encryptor.Encrypt(data.othersSalutation)
    );
    formData.append("others_name", Encryptor.Encrypt(data.othersName));
    formData.append("others_nric", Encryptor.Encrypt(data.othersNRIC));
    formData.append("others_email", Encryptor.Encrypt(data.othersEmail));
    formData.append("others_hp_no", Encryptor.Encrypt(data.othersHPNo));
    formData.append("others_dob", Encryptor.Encrypt(data.othersDOB));
    formData.append(
      "others_office_tel_no",
      Encryptor.Encrypt(data.othersOfficeTelNo)
    );
    formData.append(
      "others_designation",
      Encryptor.Encrypt(data.othersDesignation)
    );
    formData.append(
      "others_nature_of_work",
      Encryptor.Encrypt(data.othersNatureOfWork)
    );
    formData.append(
      "others_no_of_years_with_company",
      Encryptor.Encrypt(data.othersNoOfYearsWithCompany)
    );
    formData.append(
      "others_academic_qualification",
      Encryptor.Encrypt(data.othersAcademicQualification)
    );

    formData.append(
      "membership_registrationID",
      Encryptor.Encrypt(membership_registrationID)
    );

    formData.append("memberID", Encryptor.Encrypt(memberID));
    formData.append(
      "accounts_allotment",
      Encryptor.Encrypt(accounts_allotment)
    );

    // console.log(concatenatedNames);

    try {
      CorporateMembershipController.registerMemberUser(formData).then(
        (response) => {
          console.log(response);
          if (response.status === "success") {
            setShouldRefetchData((prev) => !prev); // Toggle to re-trigger useEffect
            reset(); // Clears form values

            openNotificationWithIcon("success", "Member added successfully!");
          }
        }
      );
    } catch (error) {}
  };

  const onInvalid = (errors) => {
    console.log("Form has errors:", errors);
  };

  return (
    <Box
      sx={{
        display: "flex",
        backgroundColor: "#e8e8e8",
        height: "100%",
        minHeight: "100vh",
        width: "100vw",
      }}
    >
      <Box
        component="main"
        sx={{
          flexGrow: 1,
          p: 3,
        }}
      >
        <DrawerHeader />

        <CustomSeparator pageName="add_members" />

        {contextHolder}
        <Box
          display="flex"
          justifyContent="space-between"
          alignItems="center"
          mb={2}
          mt={2}
        >
          <Typography>{data.company_name}</Typography>
          <Box display="flex" gap={2}>
            <Typography>Account Allotment:</Typography>
            <Chip label={accounts_allotment} />
            <Typography>Allotment Left:</Typography>
            <Chip label={allotmentLeft} />
          </Box>
        </Box>

        <form
          onSubmit={handleSubmit(onSubmit, onInvalid, {
            shouldFocusError: true,
          })}
        >
          {allotmentLeft > 0 ? (
            <Accordion defaultExpanded>
              <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel1-content"
                id="panel1-header"
              >
                <Box
                  sx={{
                    display: "inline-flex",
                    alignItems: "center",
                    border: "1px solid",
                    borderColor: "rgba(0, 0, 0, 0.2)",
                    borderRadius: 2,
                    bgcolor: "#d33333", // 50% opacity
                    width: "100%",
                    height: "40px",
                    color: "#ffff",
                    p: 3,
                  }}
                >
                  <Typography variant="h6" gutterBottom>
                    Add Member
                  </Typography>
                </Box>{" "}
              </AccordionSummary>
              <AccordionDetails>
                <Box
                  sx={{
                    flexGrow: 1,
                    p: 3,
                    border: "3px solid white",
                    borderRadius: "10px",
                  }}
                >
                  <Grid container spacing={2}>
                    <Grid size={{ xs: 12, md: 4 }}>
                      <Typography variant="h6" gutterBottom>
                        Salutation
                      </Typography>
                      <SelectInput
                        type="text"
                        {...register(`othersSalutation`, {
                          required: "This field is required",
                        })}
                        onErrorCheck={
                          errors.othersSalutation
                            ? errors.othersSalutation.message
                            : ""
                        }
                        control={control}
                      />
                    </Grid>

                    <Grid size={{ xs: 12, md: 8 }}>
                      <Typography variant="h6" gutterBottom>
                        Name
                      </Typography>
                      <TextInput
                        type="text"
                        {...register(`othersName`, {
                          required: "This field is required",
                        })}
                        onErrorCheck={
                          errors.othersName ? errors.othersName.message : ""
                        }
                        control={control}
                      />
                    </Grid>

                    <Grid size={{ xs: 12, md: 12 }}>
                      <Typography variant="h6" gutterBottom>
                        NRIC Number
                      </Typography>
                      <TextInput
                        type="text"
                        {...register(`othersNRIC`, {
                          required: false,
                        })}
                        onErrorCheck={
                          errors.othersNRIC ? errors.othersNRIC.message : ""
                        }
                        control={control}
                      />
                    </Grid>
                    <Grid size={{ xs: 12, md: 6 }}>
                      <Typography variant="h6" gutterBottom>
                        Date of Birth
                      </Typography>
                      <BasicDatePicker
                        {...register(`othersDOB`, {
                          required: false,
                        })}
                        onErrorCheck={
                          errors.othersDOB ? errors.othersDOB.message : ""
                        }
                        control={control}
                        name={`othersDOB`}
                      />
                    </Grid>

                    <Grid size={{ xs: 12, md: 6 }}>
                      <Typography variant="h6" gutterBottom>
                        Office Tel. No.
                      </Typography>

                      <LandLinePhoneFormatter
                        name={`othersOfficeTelNo`}
                        onErrorCheck={
                          errors.othersOfficeTelNo
                            ? errors.othersOfficeTelNo.message
                            : ""
                        }
                        control={control}
                      />
                    </Grid>
                    <Grid size={{ xs: 12, md: 6 }}>
                      <Typography variant="h6" gutterBottom>
                        H/phone No.
                      </Typography>
                      <Controller
                        name={`othersHPNo`}
                        control={control}
                        rules={{ required: "This field is required" }}
                        render={({ field }) => (
                          <MuiTelInput
                            {...field}
                            value={field.value}
                            onChange={field.onChange}
                            defaultCountry="MY"
                            sx={{
                              width: "100%",
                              "& .MuiOutlinedInput-root": {
                                fontSize: "16px",
                                borderRadius: "25px",
                                color: "black",
                                backgroundColor: "white",
                                "& fieldset": {
                                  borderColor: "#ccc",
                                },
                                "&:hover fieldset": {
                                  borderColor: "#999",
                                },
                              },
                            }}
                            error={Boolean(errors.othersHPNo)}
                            helperText={
                              errors.othersHPNo ? errors.othersHPNo.message : ""
                            }
                          />
                        )}
                      />
                    </Grid>

                    <Grid size={{ xs: 12, md: 6 }}>
                      <Typography variant="h6" gutterBottom>
                        Email
                      </Typography>
                      <TextInput
                        type="text"
                        {...register(`othersEmail`, {
                          required: "This field is required",
                        })}
                        onErrorCheck={
                          errors.othersEmail ? errors.othersEmail.message : ""
                        }
                        control={control}
                      />
                    </Grid>

                    <Grid size={{ xs: 12, md: 12 }}>
                      <Typography variant="h6" gutterBottom>
                        Designation
                      </Typography>
                      <TextInput
                        type="text"
                        {...register(`othersDesignation`, {
                          required: false,
                        })}
                        onErrorCheck={
                          errors.othersDesignation
                            ? errors.othersDesignation.message
                            : ""
                        }
                        control={control}
                      />
                    </Grid>
                    <Grid size={{ xs: 12, md: 12 }}>
                      <Typography variant="h6" gutterBottom>
                        Nature of Work
                      </Typography>
                      <TextInput
                        type="text"
                        {...register(`othersNatureOfWork`, {
                          required: false,
                        })}
                        onErrorCheck={
                          errors.othersNatureOfWork
                            ? errors.othersNatureOfWork.message
                            : ""
                        }
                        control={control}
                      />
                    </Grid>
                    <Grid size={{ xs: 12, md: 12 }}>
                      <Typography variant="h6" gutterBottom>
                        Number of Years With Company
                      </Typography>
                      <TextInput
                        type="number"
                        {...register(`othersNoOfYearsWithCompany`, {
                          required: false,
                        })}
                        onErrorCheck={
                          errors.othersNoOfYearsWithCompany
                            ? errors.othersNoOfYearsWithCompany.message
                            : ""
                        }
                        control={control}
                      />
                    </Grid>
                    <Grid size={{ xs: 12, md: 12 }}>
                      <Typography variant="h6" gutterBottom>
                        Academic Qualification
                      </Typography>
                      <SelectInput
                        type="select"
                        {...register(`othersAcademicQualification`, {
                          required: false,
                        })}
                        onErrorCheck={
                          errors.othersAcademicQualification
                            ? errors.othersAcademicQualification.message
                            : ""
                        }
                        control={control}
                      />
                    </Grid>
                  </Grid>
                </Box>
              </AccordionDetails>
            </Accordion>
          ) : (
            <Alert variant="filled" severity="info">
              The allotment for this membership is fully used. Please return to
              the main page to increase the account allotment.
            </Alert>
          )}

          {allotmentLeft > 0 && (
            <Box sx={{ marginTop: 5 }}>
              <Button
                sx={{
                  bottom: "16px", // Distance from the bottom of the screen
                  left: "0", // Position from the left edge of the screen
                  right: "0", // Position from the right edge to keep it full width
                  zIndex: 1000, // Ensure it's above other content
                  borderRadius: "20px",
                  mb: 4,
                  width: "100%", // Set initial width as a percentage
                  // maxWidth: "1150px", // Set a maximum width to avoid the button getting too large
                  minWidth: "200px", // Set a minimum width to avoid the button getting too small
                  height: "48px",
                  backgroundColor: "#d33333",
                  margin: "0 auto", // Center the button horizontally
                }}
                variant="contained"
                type="submit"
              >
                <Typography variant="h6">Save</Typography>
              </Button>
            </Box>
          )}
        </form>
      </Box>
    </Box>
  );
};

export default AddCorporateMember;
